import { render, staticRenderFns } from "./ModalSelectExhibitionProduct.vue?vue&type=template&id=c841bbd6&scoped=true"
import script from "./ModalSelectExhibitionProduct.vue?vue&type=script&lang=js"
export * from "./ModalSelectExhibitionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c841bbd6",
  null
  
)

export default component.exports